import { ev } from '../utils';
import $ from 'jquery';

export default () => {
	const burgerBtn = document.querySelector('[data-burger] .btn-burger');
	let menuState = 0;
	$(burgerBtn).on('click', (e, backToVideo = true) => {
		//console.log('e', e);
		burgerBtn.classList.toggle('is-active');
		document.body.classList.toggle('js-click-burger');

		menuState = !menuState;

		if (menuState) {
			ev('hideCursor');
			ev('pauseVideo');
		}

		if (!menuState) {
			setTimeout(() => {
				$('.menu_items').removeClass('articles-first');
			}, 500);

			ev('showCursor');
			// ev('resumeVideo');
			//console.log('backToVideo', backToVideo);
			if (backToVideo) ev('backToVideo');
		}
	});

	document.addEventListener('toggleBurgerState', (e) => {
		// e.detail.state

		if (e.detail.state) {
			$('.burger-btn-block[data-burger]').addClass('-light');
		} else {
			$('.burger-btn-block[data-burger]').removeClass('-light');
		}
	});

	document.addEventListener('showBurgerBtn', (e) => {
		document.body.classList.remove('-menu-close');
	});

	document.addEventListener('hideBurgerBtn', (e) => {
		document.body.classList.add('-menu-close');
	});

	// document.addEventListener('toggleBurgerVisibility', (e) => {
	// 	$('.burger-btn-block').toggleClass('is-hidden');
	// });
};
